exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-tech[data-v-3c8691c6]{background-color:rgba(77,192,181,.129)}", ""]);

// exports
